import * as CONSTANTS from 'common/constants/analyst-dashboards';

export const columns = [
  {
    id: CONSTANTS.COMPANY_NAME_KEY,
    label: CONSTANTS.COMPANY_NAME,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.STATUS_KEY,
    label: CONSTANTS.STATUS,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.NOTES_KEY,
    label: CONSTANTS.NOTES,
    isSortable: false,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.OTHER_CONSULTANT_KEY,
    label: CONSTANTS.OTHER_CONSULTANT,
    isSortable: false,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.ENGAGEMENT_MANAGER_KEY,
    label: CONSTANTS.ENGAGEMENT_MANAGER,
    isSortable: false,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.VALUATION_DATE_KEY,
    label: CONSTANTS.VALUATION_DATE,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.CREATED_AT_KEY,
    label: CONSTANTS.CREATED_AT,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.VALUATION_FEE_KEY,
    label: CONSTANTS.VALUATION_FEE,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.DEAL_KEY,
    label: CONSTANTS.DEAL,
    isSortable: false,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.DEAL_DUE_KEY,
    label: CONSTANTS.DEAL_DUE,
    isSortable: false,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.DEAL_STAGE_KEY,
    label: CONSTANTS.DEAL_STAGE,
    isSortable: false,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.NET_VALUE_KEY,
    label: CONSTANTS.NET_VALUE,
    isSortable: false,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.SPLIT_KEY,
    label: CONSTANTS.SPLIT,
    isSortable: false,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.PAYMENT_1_KEY,
    label: CONSTANTS.PAYMENT_1,
    isSortable: false,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.PAY_1_DATE_KEY,
    label: CONSTANTS.PAY_1_DATE,
    isSortable: false,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.PAYMENT_2_KEY,
    label: CONSTANTS.PAYMENT_2,
    isSortable: false,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.PAY_2_DATE_KEY,
    label: CONSTANTS.PAY_2_DATE,
    isSortable: false,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.PAYMENT_3_KEY,
    label: CONSTANTS.PAYMENT_3,
    isSortable: false,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.PAY_3_DATE_KEY,
    label: CONSTANTS.PAY_3_DATE,
    isSortable: false,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.REFUND_KEY,
    label: CONSTANTS.REFUND,
    isSortable: false,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.REFUND_DATE_KEY,
    label: CONSTANTS.REFUND_DATE,
    isSortable: false,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.DUE_KEY,
    label: CONSTANTS.DUE,
    isSortable: false,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.ADJUSTMENT_KEY,
    label: CONSTANTS.ADJUSTMENT,
    isSortable: false,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.ADJUSTMENT_DATE_KEY,
    label: CONSTANTS.ADJUSTMENT_DATE,
    isSortable: false,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.BAD_DEBT_KEY,
    label: CONSTANTS.BAD_DEBT,
    isSortable: false,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.BAD_DEBT_DATE_KEY,
    label: CONSTANTS.BAD_DEBT_DATE,
    isSortable: false,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.RENEWAL_RATE_KEY,
    label: CONSTANTS.RENEWAL_RATE,
    isSortable: false,
    align: 'left',
    disablePadding: false,
  },
];
